import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import HeaderSectionLeft from "./HeaderSectionLeft.jsx"
import HeaderSectionRight from "./HeaderSectionRight.jsx"
import CMSData from "aldoo-ra/CMS/cms-data"

const HeaderSection = () => {
  // SSR-fetched section renders the hero (LCP element) on the first client
  // pass instead of waiting for the client CMS fetch; CMSData takes over.
  const { homeHeroSection } = usePageContext()
  const ssrSection =
    homeHeroSection?.name === "AndroidHomeHeader" ? homeHeroSection : null

  //Load the data for the section from the CMS
  const { data } = CMSData({
    contentType: "PageSection",
    match: { "content.name": "AndroidHomeHeader" },
  })

  const section = data?.[0] || ssrSection
  if (!section) return null

  // All classes are the same for all platforms to ensure same layout
  return (
    <div className="w-full px-6 md:px-[48px] lg:px-[56px] xl:px-[96px]">
      <div className="relative flex flex-col md:flex-row w-full md:max-w-[800px] lg:max-w-[900px] xl:max-w-[1380px] 2xl:max-w-w1_xl justify-between items-center md:items-start gap-6 2xl:gap-0 pt-8 md:pt-[88px] lg:pt-8 xl:pt-0 mx-auto">
        <HeaderSectionLeft data={section} />
        <HeaderSectionRight data={section} />
      </div>
    </div>
  )
}

export const AldooComponent = {
  id: 'HeaderSection',
  component: HeaderSection,
  input: {},
  meta: {
    name: 'Header Section',
    description: 'Hero section with left/right layout',
    category: 'Marketing',
  },
}

export default HeaderSection
